/**
 * Created by Nisarg on 7/19/2017.
 */
import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {ModalContainer, ModalDialog} from 'react-modal-dialog';
import firebase from 'firebase';
import $ from 'jquery';
import _HauteFire from './HauteFire';

const HauteFire = new _HauteFire();

export default class Footer extends Component {
    constructor() {
        super();

        this.state = {
            isModalShown: false,
            modalContent: "",
            isSubscribeModalShown: false,
            subscription: {},
            facebook: "",
            twitter: "",
            instagram: "",
            pinterest: ""
        }
    }

    componentDidMount() {
        const _this = this;
        let hauteRef = firebase.database().ref('HauteDetails');
        hauteRef.on('value', (response) => {
            const HauteDetails = response.val();
            if (HauteDetails != null) {
                if (HauteDetails.hasOwnProperty('socialManagement')) {
                    const socialManagement = HauteDetails.socialManagement;
                    if (socialManagement.hasOwnProperty('facebook')) {
                        _this.setState({facebook: socialManagement.facebook});
                    }
                    if (socialManagement.hasOwnProperty('twitter')) {
                        _this.setState({twitter: socialManagement.twitter});
                    }
                    if (socialManagement.hasOwnProperty('instagram')) {
                        _this.setState({instagram: socialManagement.instagram});
                    }
                    if (socialManagement.hasOwnProperty('pinterest')) {
                        _this.setState({pinterest: socialManagement.pinterest});
                    }
                }
            }
        })
    }

    handleClick(e) {
        let content = e.currentTarget.attributes["data-content"].value;
        let contentType = e.currentTarget.attributes["data-content"].value;
        if (content == "Contact") {
            content = 'Email us : info@hauteislands.com';
            // $("p#pEmail").html("Email us : info@hauteislands.com");
        }

        this.setState({isModalShown: true, modalContent: content}, () => {
            if (contentType == "Contact") {
                $("p#pContactNum").html("Contact us : +919820455164");
            }
        });
    }

    subscribeClick(e) {
        this.setState({isSubscribeModalShown: true}, () => {
            $("#txtFirstName").focus();
        });
    }

    subscribeHandleClose(e) {
        this.setState({isSubscribeModalShown: false});
    }

    handleClose() {
        this.setState({isModalShown: false});
    }

    checkEmailExistance(email) {
        $("button#btnSubscribe").html("<i class=\"fa fa-spinner fa-spin fa-3x fa-fw\"></i> Loading");
        $("button#btnSubscribe").attr("disabled", "disabled");

        function* emailGenerator() {
            let personRef = firebase.database().ref('/Subscription');
            let person = yield personRef.orderByChild('email').equalTo(email).once('value').then((response) => {
                if (response.val() != null) {
                    return true;
                }
                else {
                    return false;
                }
            });
        }

        let emailGen = emailGenerator();
        let yielded = emailGen.next();
        yielded.value.then((isExist) => {
            if (!isExist) {
                $("#txtEmail").removeClass("reqrecpt");
                $("#errEmail").hide();

                $("button#btnSubscribe").html("<i class=\"fa fa-envelope-o\" aria-hidden=\"true\"></i> Subscribe");
                $("button#btnSubscribe").removeAttr("disabled");

                let subscription = this.state.subscription;
                subscription.email = email;

                this.setState({subscription});
            }
            else {
                $("#errEmail").show();
                $("#txtEmail").addClass("reqrecpt").focus();
            }
        });
    }

    addSubscription(e) {
        e.preventDefault();
        let isValid = true;
        let controls = $("form#formSubsciption input");
        $(controls).removeClass("reqrecpt");

        $("form#formSubsciption input").each((index, elem) => {
            if ($(elem).val() == "") {
                $(elem).addClass("reqrecpt").focus();

                isValid = false;
                return false;
            }
        });

        if (isValid) {
            let {subscription} = this.state;
            subscription.id = Date.now();

            firebase.database().ref('/Subscription/' + subscription.id).set(subscription);
            this.subscribeHandleClose(e);

            this.setState({isModalShown: true, modalContent: "You have successfully subscribed :)"});
        }

        return false;
    }

    render() {
        return (
            <footer className="footer">
                <Link className="logo" to="/">
                    <img src="../../assets/images/footer-logo.png" alt=""/>
                </Link>
                <ul className="footer-nav">
                    <li><a data-content="The information contained on this website (including all logos, labels, designs copyrights, and trademarks (collectively, “Information”) is the exclusive property of Haute Islands LLP (“HIL”).

HIL reserves all rights to use the entire content on this website and Information in any manner it chooses. By entering on this website and availing the services offered by HIL, you are agreeing to be bound by HIL’s internal polices and being contractually bound by terms on which HIL does business.

Unauthorized use, disclosure or copying of Information or any part thereof is strictly prohibited and may be unlawful.  If you have used the Information in error or on purpose, please notify us immediately and destroy the Information and all copies thereof immediately.

HIL shall not liable for any Information used by you or for any damages sustained by you in relation to visiting this website or availing the services offered by HIL."
                           style={{cursor: 'pointer'}}
                           onClick={this.handleClick.bind(this)}>LEGAL</a></li>
                    {/*
                    <li><a data-content="Faqs" style={{cursor:'pointer'}} onClick={this.handleClick.bind(this)}>FAQS</a>
                    </li>
                    */}
                    <li><a data-content="Contact" style={{cursor: 'pointer'}} onClick={this.handleClick.bind(this)}>CONTACT</a>
                    </li>
                    <li><a style={{cursor: 'pointer'}} onClick={this.subscribeClick.bind(this)}>SUBSCRIBE</a>
                    </li>
                    {/*
                    <li><a data-content="Destinations" style={{cursor: 'pointer'}}
                           onClick={this.handleClick.bind(this)}>DESTINATIONS</a>
                    </li>
                    */}
                </ul>
                <ul className="social-nav clearfix">
                    {this.state.facebook != "" ?
                        <li><a className="icon-fb" target="_blank" href={this.state.facebook}></a></li> : ""}
                    {this.state.twitter != "" ?
                        <li><a className="icon-twt" target="_blank" href={this.state.twitter}></a></li> : ""}
                    {this.state.instagram != "" ?
                        <li><a className="icon-insta" target="_blank" href={this.state.instagram}></a></li> : ""}
                    {this.state.pinterest != "" ?
                        <li><a className="icon-pi" target="_blank" href={this.state.pinterest}></a></li> : ""}
                </ul>

                {this.state.isModalShown ? <ModalContainer onClose={this.handleClose.bind(this)}>
                    <ModalDialog onClose={this.handleClose.bind(this)}>
                        <p
                            style={{fontWeight: 'bold'}}>{this.state.modalContent}</p>
                        <p id="pContactNum" style={{fontWeight: 'bold'}}></p>
                    </ModalDialog>
                </ModalContainer> : ""}

                {this.state.isSubscribeModalShown ?
                    <ModalContainer onClose={this.subscribeHandleClose.bind(this)} style={{width: 400}}>
                        <ModalDialog onClose={this.subscribeHandleClose.bind(this)} style={{width: 400}}>

                            <form id="formSubsciption">
                                <p className="h5 text-center mb-4">Subscribe to us</p>

                                <div className="md-form">
                                    <input type="text" id="txtFirstName" className="form-control" onChange={(e) => {
                                        let firstName = e.currentTarget.value.trim();
                                        let subscription = this.state.subscription;
                                        if (firstName != "") {
                                            subscription.firstName = firstName;

                                            this.setState({subscription});
                                        }
                                    }
                                    }/>
                                    <label htmlFor="txtFirstName">First name</label>
                                </div>

                                <div className="md-form">
                                    <input type="text" id="txtLastName" className="form-control" onChange={(e) => {
                                        let lastName = e.currentTarget.value.trim();
                                        let subscription = this.state.subscription;
                                        if (lastName != "") {
                                            subscription.lastName = lastName;

                                            this.setState({subscription});
                                        }
                                    }
                                    }/>
                                    <label htmlFor="txtFirstName">Last name</label>
                                </div>

                                <div className="md-form">
                                    <input type="email" id="txtEmail" className="form-control" onChange={(e) => {
                                        let email = e.currentTarget.value.trim();
                                        let subscription = this.state.subscription;
                                        if (email != "") {
                                            $(e.currentTarget).addClass("reqrecpt").focus();
                                            if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
                                                this.checkEmailExistance(email);
                                            }
                                        }
                                    }
                                    }/>
                                    <label htmlFor="txtEmail">Email</label>
                                    <span id="errEmail" className="errmsg"
                                          style={{display: 'none'}}>Already subscribed</span>
                                </div>

                                <div className="md-form">
                                    <input type="text" id="txtContactNumber" className="form-control" onChange={(e) => {
                                        let contactNumber = e.currentTarget.value.trim();
                                        let subscription = this.state.subscription;
                                        if (contactNumber != "") {
                                            subscription.contactNumber = contactNumber;

                                            this.setState({subscription});
                                        }
                                    }}/>
                                    <label htmlFor="txtContactNumber">Contact number</label>
                                </div>

                                <div className="md-form">
                                <span id="errRecpt" className="errmsg"
                                      style={{display: 'none'}}>All fields are mendatory</span>
                                </div>
                                <div className="text-center">
                                    <button id="btnSubscribe" className="btn btn-unique"
                                            onClick={this.addSubscription.bind(this)}>
                                        <i className="fa fa-envelope-o" aria-hidden="true"></i> Subscribe
                                    </button>
                                </div>
                            </form>

                        </ModalDialog>
                    </ModalContainer>
                    :
                    ""
                }

            </footer>
        )
    }
}



// WEBPACK FOOTER //
// ./src/Footer.js